"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var circle_1 = tslib_1.__importDefault(require("./circle"));
var guide_1 = tslib_1.__importDefault(require("./guide"));
exports.default = {
    guide: guide_1.default,
    circle: circle_1.default,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/geoms/point/index.js
// module id = 866
// module chunks = 37